@let localMarker = marker();

<div class="card rounded-4 h-100 p-0 w-100" [class]="isCarousel() ? 'shadow-sm' : 'shadow-lg'">
  <div class="card-image cursor-pointer position-relative" (click)="goToMarker()">
    <img
      [lazyLoad]="localMarker?.image | cdnUrl: 500 : true"
      [alt]="localMarker?.language?.name"
      class="w-100 h-100 object-fit-cover rounded-top-4"
    />

    @if (localMarker?.has_vr) {
      <div class="item-vr rounded-circle bg-white position-absolute end-0 top-0 mt-2 me-2">
        <img
          class="object-fit-contain h-100 w-100"
          src="img/icons/ra_icon_circle.png"
          alt="has_vr"
        />
      </div>
    }
  </div>

  <div class="card-body d-flex flex-column justify-content-between">
    <div class="info mb-3">
      <div class="d-flex align-items-start gap-2 mb-1">
        <img
          class="me-0 object-fit-contain"
          width="22"
          [lazyLoad]="localMarker?.marker_category?.icon_list | cdnUrl: 100 : true"
        />
        <div class="title d-inline-block text-lines-2 fw-bold fs-6">
          {{ localMarker.language?.name }}
        </div>
      </div>
      <p class="mb-0 fw-light">
        {{ 'in' | translate }}
        <a class="dark-blue-text cursor-pointer text-decoration-none" (click)="goToCity()">{{
          location()
        }}</a>
      </p>
      <div class="d-flex align-items-center flex-wrap row-gap-2 column-gap-3 mt-1">
        <div class="content-qualification d-flex align-items-center gap-1">
          <span class="item-rating-numbers bg-dark-blue text-white px-2">{{
            qualification()
          }}</span>
          <i class="inm-icon-star yellow-text"></i>
          <span class="fw-light"> ({{ localMarker.qualifications || 0 }} Calificaciones) </span>
        </div>

        <div class="d-flex align-items-center gap-1">
          <i class="inm-icon-comment"></i>
          <span class="fw-light"
            >{{ localMarker?.valuations || 0 }} {{ '$valuations_text_plural' | translate }}</span
          >
        </div>
      </div>

      @let localDescription = description();
      @if (localDescription) {
        <div class="description text-lines-3 mt-2" [innerHTML]="localDescription"></div>
      }
    </div>

    <div class="d-flex flex-column gap-2 mt-auto">
      <button (click)="goToMarker()" class="yellow full fw-normal rounded-4 shadow-sm">
        {{ 'show_marker_profile' | translate }}
      </button>

      @if (showBtnMap()) {
        <button
          class="white full rounded-4 d-flex align-items-center justify-content-center text-center gap-2 shadow-sm"
          (click)="goToMap()"
        >
          <i class="inm-icon-map"></i>
          {{ 'show_in_map' | translate }}
        </button>
      }
    </div>
  </div>
</div>
